import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const searchCustomersList = (payload) => {
    return api.makeRequest({
        url: `/crm/searchCustList`,
        method: 'POST',
        data: payload
    })
}

export const detailCustomersList = (payload) => {
    return api.makeRequest({
        url: `/crm/searchCustInList`,
        method: 'POST',
        data: payload
    })
}

export const addCustomerToList = (payload) => {
    return api.makeRequest({
        url: `/crm/addCustToList`,
        method: 'POST',
        data: payload
    })
}

export const deleteCustomerToList = (payload) => {
    return api.makeRequest({
        url: `/crm/removeCustFromList`,
        method: 'POST',
        data: payload
    })
}

export const imporListCustomers = (custListName, createBy, payload) => {
    return api.makeRequest({
        url: `/crm/uploadCustList?createBy=${createBy}&custListName=${custListName}`,
        method: 'POST',
        data: payload
    })
}
